"use strict";
// Copyright (c) 2025 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OID_EMAIL_ADDRESS = exports.OID_COMMON_NAME = exports.OID_ORGANIZATIONAL_UNIT_NAME = exports.OID_ORGANIZATION_NAME = exports.OID_LOCALITY_NAME = exports.OID_STATE_OR_PROVINCE_NAME = exports.OID_COUNTRY_NAME = exports.OID_SECP384R1 = exports.OID_PRIME256V1 = exports.OID_ANSIP256K1 = exports.OID_EC_PUBLIC_KEY = exports.OID_ECDSA_WITH_SHA384 = exports.OID_ECDSA_WITH_SHA256 = exports.OID_RSA_SHA512 = exports.OID_RSA_SHA384 = exports.OID_RSA_SHA256 = void 0;
exports.OID_RSA_SHA256 = '1.2.840.113549.1.1.11';
exports.OID_RSA_SHA384 = '1.2.840.113549.1.1.12';
exports.OID_RSA_SHA512 = '1.2.840.113549.1.1.13';
exports.OID_ECDSA_WITH_SHA256 = '1.2.840.10045.4.3.2';
exports.OID_ECDSA_WITH_SHA384 = '1.2.840.10045.4.3.3';
exports.OID_EC_PUBLIC_KEY = '1.2.840.10045.2.1';
exports.OID_ANSIP256K1 = '1.3.132.0.10';
exports.OID_PRIME256V1 = '1.2.840.10045.3.1.7';
exports.OID_SECP384R1 = '1.3.132.0.34';
exports.OID_COUNTRY_NAME = '2.5.4.6';
exports.OID_STATE_OR_PROVINCE_NAME = '2.5.4.8';
exports.OID_LOCALITY_NAME = '2.5.4.7';
exports.OID_ORGANIZATION_NAME = '2.5.4.10';
exports.OID_ORGANIZATIONAL_UNIT_NAME = '2.5.4.11';
exports.OID_COMMON_NAME = '2.5.4.3';
exports.OID_EMAIL_ADDRESS = '1.2.840.113549.1.9.1';
//# sourceMappingURL=x509.js.map